import { render, staticRenderFns } from "./ExPagination.vue?vue&type=template&id=4699f6ed"
import script from "./ExPagination.vue?vue&type=script&lang=js"
export * from "./ExPagination.vue?vue&type=script&lang=js"
import style0 from "./ExPagination.vue?vue&type=style&index=0&id=4699f6ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports